import { directiveResolveParams } from '../util';

export default {
    // called before bound element's attributes
    // or event listeners are applied
    created(el, binding, vnode, prevVnode) {
    },
    // called right before the element is inserted into the DOM.
    beforeMount(el, binding, vnode, prevVnode) {},
    // called when the bound element's parent component
    // and all its children are mounted.
    mounted(el, binding, vnode, prevVnode) {
        const targetSelector = '.content'; // Content element selector
        const actionSelector = '.read-more'; // "Read more" button selector
        const maxLines = 2; // Maximum number of lines before showing the button
        const target = el.querySelector(targetSelector);
        const readMoreButton = el.querySelector(actionSelector);

        if (!target || !readMoreButton) {
            console.error("Required elements (.content or .read-more) are missing in the DOM.");
            return;
        }

        // Function to check if the content exceeds the allowed number of lines
        const checkContentOverflow = () => {
            // Get the computed line height of the target element
            const lineHeight = parseFloat(getComputedStyle(target).lineHeight);

            // Calculate the maximum height based on the allowed number of lines
            const maxHeight = lineHeight * maxLines;

            // Temporarily apply the max height to test for overflow
            target.style.maxHeight = `${maxHeight}px`;
            target.style.overflow = 'hidden';

            // Check if the content actually exceeds the visible area
            if (target.scrollHeight > maxHeight) {
                // Content exceeds the limit; show the "Read more" button
                readMoreButton.style.display = 'inline-block';
            } else {
                // Content fits within the limit; hide the "Read more" button
                readMoreButton.style.display = 'none';
            }
        };

        // Add an event listener for the "Read more" button
        readMoreButton.addEventListener('click', (e) => {
            e.preventDefault();

            // Remove height restriction and hide the button
            target.style.maxHeight = 'none';
            target.style.overflow = 'visible';
            readMoreButton.style.display = 'none';
        });

        // Initial check for overflow
        checkContentOverflow();

        // Re-check on window resize to handle responsive layout changes
        const onResize = () => {
            checkContentOverflow();
        };
        window.addEventListener('resize', onResize);

        // Cleanup event listener when the component is unmounted
        el._resizeCleanup = onResize; // Save reference to remove later
    },

    // called before the parent component is updated
    beforeUpdate(el, binding, vnode, prevVnode) {},
    // called after the parent component and
    // all of its children have updated
    updated(el, binding, vnode, prevVnode) {},
    // called before the parent component is unmounted
    beforeUnmount(el, binding, vnode, prevVnode) {
        // Remove the resize event listener to prevent memory leaks
        window.removeEventListener('resize', el._resizeCleanup);
    },
    // called when the parent component is unmounted
    unmounted(el, binding, vnode, prevVnode) {}
}
